module.exports = __webpack_public_path__ + "28b67065/img/chevron-down-icon.5542f65c.svg";